<script setup lang="ts">
import { RowInfo } from '@shared/ui/other'

import { useTutorKanbanPreviousStage } from '../model/use-tutor-kanban-previous-stage.hook'

defineOptions({
  name: 'TutorKanbanPreviousStage',
})

const { refLabel } = useTutorKanbanPreviousStage()
</script>

<template>
  <RowInfo
    title="Previous stage"
    :value="refLabel"
  />
</template>
